export default __webpack_public_path__ + "static/media/IMG_2049.7a7152cf.jpg";